import React, { useEffect, useState, useRef } from 'react';
import './About.css';

const stats = [
  { target: 3, suffix: '+', description: 'Years of research-led innovation in livestock health technology.' },
  { target: 13000, prefix: '₹', suffix: ' Cr', description: 'Estimated dairy losses in India — we’re on a mission to reduce it.' },
  { target: 200, suffix: 'M+', description: 'Litres of milk at risk annually — we aim to protect every drop.' },
  { target: 1, suffix: ' Goal', description: 'Healthier animals. Stronger farms. Sustainable dairy futures.' }
];

const About = () => {
  const [counts, setCounts] = useState(stats.map(() => 0));
  const [hasAnimated, setHasAnimated] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
  const observerTarget = sectionRef.current; // ✅ Store it here

  const observer = new IntersectionObserver(
  entries => {
    if (entries[0].isIntersecting && !hasAnimated) {
      animateCounters();
      setHasAnimated(true);
    }
  },
  { threshold: 0.25 } // ✅ reduced from 0.5
);


  if (observerTarget) {
    observer.observe(observerTarget);
  }

  return () => {
    if (observerTarget) observer.unobserve(observerTarget); // ✅ Use the stored variable
  };
}, [hasAnimated]);


  const animateCounters = () => {
    const durations = 2300; // ms
    const steps = 80;
    const intervalTime = durations / steps;

    let step = 0;
    const interval = setInterval(() => {
      setCounts(prev => {
        return prev.map((count, i) => {
          const increment = stats[i].target / steps;
          const nextVal = count + increment;
          return nextVal >= stats[i].target ? stats[i].target : nextVal;
        });
      });

      step++;
      if (step >= steps) clearInterval(interval);
    }, intervalTime);
  };

  return (
    <section id="about" className="about-section" ref={sectionRef} data-aos="fade-up">
      <div className="about-container">
        <div className="about-text">
          <h2 className="about-title">About Us</h2>
          <p className="about-subtitle">Where Smart Tech Meets Livestock Care</p>

          <p>
            Founded in 2020, AK Technologies is dedicated to delivering cutting-edge, data-driven solutions to complex, real-world challenges. Our mission goes beyond innovation — we aim to create sustainable impact through technology, research, and collaboration.
          </p>
          
          <p>
            With a passionate team spanning autonomous sensing systems, artificial intelligence, urban strategy, and business development, we bring multidisciplinary expertise to the table. One of our key focus areas is animal health and dairy sustainability, where we leverage smart tech to tackle issues like mastitis — a silent yet economically damaging disease affecting India’s dairy industry.
          </p>
          <p>We are a Startup India-recognized company, registered under DPIIT with recognition number DPII158932, reaffirming our commitment to innovation, scalability, and national development.
          </p>
          
          <p>
            At AK Technologies, we believe that technology should empower communities, enhance livestock welfare, and drive long-term economic growth. Whether it’s transforming cities or improving the lives of farmers and animals, our team is committed to delivering solutions that matter.
          </p>

          <div className="impact-row">
            {stats.map((stat, i) => (
              <div className="impact-item" key={i}>
                <h3>
  {stat.prefix || ''}
  <span className="counter-number">{Math.min(Math.round(counts[i]), stats[i].target)}</span>
  <span className="counter-suffix">{stat.suffix}</span>
</h3>


                <p>{stat.description}</p>
                {i < stats.length - 1 && <div className="vertical-line" />}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
